export const ITEMS_GET = "ITEMS::SUBMITTED_GET";
export const ITEMS_RECEIVE = "ITEMS::SUBMITTED_GET_RECEIVE";
export const ITEMS_ERROR = "ITEMS::SUBMITTED_GET_ERROR";
